import { NextPromotion, Promotion } from '@/types/promotion';

export enum ActionTypes {
  FETCH_PROMOTIONS_START = 'promotions/FETCH_PROMOTIONS_START',
  FETCH_PROMOTIONS_SUCCESS = 'promotions/FETCH_PROMOTIONS_SUCCESS',
  FETCH_PROMOTIONS_FAIL = 'promotions/FETCH_PROMOTIONS_FAIL',
  CHANGE_PAGE = 'promotions/CHANGE_PAGE',
  SET_SELECTED_PROMOTION = 'promotions/SET_SELECTED_PROMOTION',
  CLEAR_PROMOTIONS = 'promotions/CLEAR_PROMOTIONS',
  ADD_SELECTED_PROMOTION = 'promotions/ADD_SELECTED_PROMOTION',
  RESET_PROMOTIONS_STATE = 'promotions/RESET_PROMOTIONS_STATE',
}

export interface State {
  isLoading: boolean;
  error: string;
  items: NextPromotion[];
  page: number;
  totalItems: number;
  selected?: NextPromotion | undefined;
}

export interface FetchPromotionsStartAction {
  type: ActionTypes.FETCH_PROMOTIONS_START;
}
export interface FetchPromotionsSuccessAction {
  type: ActionTypes.FETCH_PROMOTIONS_SUCCESS;
  payload: any[];
  totalItems: number;
}
export interface FetchPromotionsFailAction {
  type: ActionTypes.FETCH_PROMOTIONS_FAIL;
  payload: string;
}

export interface ChangePage {
  type: ActionTypes.CHANGE_PAGE;
  payload: number;
}

export interface AddSelectedPromotion {
  type: ActionTypes.ADD_SELECTED_PROMOTION;
  payload: Promotion | undefined;
}

export interface SetSelectedPromotion {
  type: ActionTypes.SET_SELECTED_PROMOTION;
  payload: Promotion | undefined;
}

export interface ClearPromotions {
  type: ActionTypes.CLEAR_PROMOTIONS;
}

export interface ResetPromotionsState {
  type: ActionTypes.RESET_PROMOTIONS_STATE;
}

export type ActionType =
  | FetchPromotionsStartAction
  | FetchPromotionsSuccessAction
  | FetchPromotionsFailAction
  | ChangePage
  | SetSelectedPromotion
  | AddSelectedPromotion
  | ClearPromotions
  | ResetPromotionsState;
